import { z } from 'zod';

export const MetaTags = z
  .object({
    canonical_url: z.string().optional(),
    description: z.string().optional(),
    image_src: z.string().optional(),
    og_description: z.string().optional(),
    og_image: z.string().optional(),
    og_image_alt: z.string().optional(),
    og_image_height: z.string().optional(),
    og_image_type: z.string().optional(),
    og_image_url: z.string().optional(),
    og_image_width: z.string().optional(),
    og_site_name: z.string().optional(),
    og_title: z.string().optional(),
    og_type: z.string().optional(),
    og_url: z.string().optional(),
    robots: z.string().optional(),
    schema_business_description: z.string().optional(),
    schema_business_id: z.string().optional(),
    schema_business_name: z.string().optional(),
    schema_business_telephone: z.string().optional(),
    schema_business_url: z.string().optional(),
    title: z.string().optional(),
  })
  .transform((val) => {
    const {
      og_description,
      og_image,
      og_image_alt,
      og_image_height,
      og_image_type,
      og_image_url,
      og_image_width,
      og_site_name,
      og_title,
      og_type,
      og_url,
      ...rest
    } = val;

    let mapped = {};

    if (og_description) {
      mapped = {
        ...mapped,
        'og:description': og_description,
      };
    }
    if (og_image) {
      mapped = {
        ...mapped,
        'og:image': og_image,
      };
    }
    if (og_image_alt) {
      mapped = {
        ...mapped,
        'og:image:alt': og_image_alt,
      };
    }
    if (og_image_height) {
      mapped = {
        ...mapped,
        'og:image:height': og_image_height,
      };
    }
    if (og_image_type) {
      mapped = {
        ...mapped,
        'og:image:type': og_image_type,
      };
    }
    if (og_image_url) {
      mapped = {
        ...mapped,
        'og:image:url': og_image_url,
      };
    }
    if (og_image_width) {
      mapped = {
        ...mapped,
        'og:image:width': og_image_width,
      };
    }
    if (og_site_name) {
      mapped = {
        ...mapped,
        'og:site:name': og_site_name,
      };
    }
    if (og_title) {
      mapped = {
        ...mapped,
        'og:title': og_title,
      };
    }
    if (og_type) {
      mapped = {
        ...mapped,
        'og:type': og_type,
      };
    }
    if (og_url) {
      mapped = {
        ...mapped,
        'og:url': og_url,
      };
    }

    return {
      ...mapped,
      ...rest,
    };
  });

export type MetaTags = z.infer<typeof MetaTags>;
